<!-- ALERT TOAST-->
<p-toast></p-toast>

<!-- CONFIRMATION DIALOG-->
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>

<!-- OVERLAY SCREEN-->
<div *ngIf="blocked " class="overlay">
    <img src="assets/layout/images/tovlogo.png" alt="Loading Icon" class="loading-image" />
    <span style="color: white; font-size: large;">{{translations.lbl_loading}}</span>
</div>

<!-- MAIN SCREEN -->
<div class="card">
    <div class="section p-d-flex p-flex-column p-ai-left">
        <!-- TOOLBAR -->
        <p-toolbar styleClass="p-mb-4">
            <ng-template pTemplate="left">
                <button pButton type="button" label="{{translations.lbl_back}}" *ngIf="this.clipBoardPressed"
                    class="p-button-danger p-mr-1" icon="pi pi-chevron-left" (click)="goBack()"></button>

                <button pButton type="button" label="{{translations.lbl_accept}}" *ngIf="this.clipBoardPressed"
                    class="p-button-success p-mr-1" icon="pi pi pi-plus" (click)="goAccept()"></button>
            </ng-template>
        </p-toolbar>

    </div>

    <div class="p-grid">
        <div class="p-col-12 p-md-6">
            <p-panel>

                <!-- INFO FORM -->
                <div class="p-xl-12 p-lg-12 p-md-12 p-sm-12 p-xs-12">

                    <!-- EMAILS SEACH -->
                    <div class="p-formgrid p-grid p-ai-center p-jc-between p-pt-1 p-py-1">
                        <div class="subTitle p-col-12 p-md-4">
                            <span>Busqueda por {{translations.lbl_email}}</span>
                        </div>
                        <div class="p-col-12 p-md-4">
                            <input type="text" pInputText [(ngModel)]="searchingEmail">
                        </div>
                        <div class="p-col-12 p-md-2">
                            <button class="button-copy" pButton type="button" icon="pi pi-search"
                                (click)="addEmailsToTable()"></button>
                        </div>
                        <!-- BUTTON PACKAGE INPUT -->
                        <div *ngIf="!this.clipBoardPressed" class="p-col-12 p-md-2">
                            <button class="button-save" pButton type="button" label="{{translations.lbl_accept}}"
                                (click)="goClipBoard()"></button>
                        </div>
                    </div>

                    <br />

                </div>

            </p-panel>
        </div>
    </div>

    <p-table #dt [value]="lstEmails" [(selection)]="selectedEmails" [globalFilterFields]="['email','country','status']"
        [paginator]="true" [rows]="25" [rowHover]="true" dataKey="id" styleClass="p-datatable-responsive-demo"
        currentPageReportTemplate="{{translations.lbl_showing}} {first} {{translations.lbl_of}} {last} {{translations.lbl_records}}"
        [showCurrentPageReport]="true">

        <!-- CAPTION -->
        <ng-template pTemplate="caption">
            <div class="p-d-flex p-ai-left p-jc-between responsive">
                <div>
                    <button pButton pRipple (click)="copyText()" pTooltip="Copiar emails" type="button"
                        icon="pi pi-copy" class="p-button-rounded p-m-2 z-5"></button>

                    <i class="pi pi-check-circle p-m-2 z-5 p-text-primary"
                        [pTooltip]="translations.lbl_total + ' Aceptados'" severity="success" pBadge
                        style="font-size: 2rem" value={{totAccepted}}></i>

                    <i class="pi pi-ban p-m-2 z-5 p-text-secondary" severity="danger"
                        [pTooltip]="translations.lbl_total + ' Rechazados'" pBadge style="font-size: 2rem"
                        value={{totRejected}}></i>

                </div>

                <div class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                        placeholder="{{translations.lbl_search}}..." />
                </div>
            </div>
        </ng-template>

        <!-- HEADER -->
        <ng-template pTemplate="header">
            <tr>
                <th pSortableColumn="selectH" [hidden]="!checDisaled()"></th>

                <th pSortableColumn="email">{{translations.lbl_email}}<p-sortIcon field="email">
                    </p-sortIcon>
                </th>
                <th pSortableColumn="country">{{translations.lbl_country}}<p-sortIcon field="country">
                    </p-sortIcon>
                </th>
                <th pSortableColumn="status">{{translations.lbl_status}}<p-sortIcon field="status">
                    </p-sortIcon>
                </th>
                <th pSortableColumn="select" [hidden]="checDisaled()">{{translations.lbl_select}} los rechazados
                </th>
            </tr>
        </ng-template>

        <!-- BODY -->
        <ng-template pTemplate="body" let-value>
            <tr>
                <td>
                    <div [ngClass]="{'rejectedEml': value.status === 'M','acceptedEml': value.status === 'L' }">
                        {{value.email}}
                    </div>
                </td>
                <td>{{value.country}}</td>
                <td>{{value.status}}</td>
                <td>
                    <button *ngIf="value.status !== 'L' && value.status !== 'M'" type="button" pButton pRipple
                        icon="pi pi-pencil" pTooltip="{{translations.lbl_edit}}" (click)="getEmailModal(value)"
                        class="p-button-warning p-m-2 p-button-rounded">
                    </button>
                    <p-checkbox *ngIf="value.status === 'L' || value.status === 'M'" name="group1"
                        [hidden]="checDisaled()" value="{{value.email}}" [(ngModel)]="selectedEmails"
                        inputId="{{value.email}}" (onChange)="checkValue(value.email,selectedEmails)"></p-checkbox>
                </td>
            </tr>
        </ng-template>

        <!-- SUMMARY -->
        <ng-template pTemplate="summary">
            <div class="p-d-flex p-ai-center p-jc-between">
                {{translations.lbl_total}} {{lstEmails ? lstEmails.length : 0 }}
                {{translations.lbl_records}}.
            </div>
        </ng-template>
    </p-table>
</div>

<!-- DIALOG ESTATUS -->
<p-dialog header="{{translations.lbl_edit}}" [(visible)]="modalStatus" styleClass="p-fluid" [modal]="true"
    [style]="{width: '50vw'}" [maximizable]="true" [baseZIndex]="10000" [draggable]="false" [resizable]="false"
    (onHide)="closeModal()">
    <div class="card">
        <!-- INPUTS -->
        <div class="p-grid">
            <!-- 1ST SECTION INFO -->
            <div class="p-col-12">
                <div class="p-fluid" [formGroup]="emailsForm">

                    <!-- Status -->
                    <div class="p-col-12">
                        <label for="statusModal">{{translations.lbl_status}}</label>
                        <p-dropdown id="statusModal" [options]="lstStatus" formControlName="status"
                            placeholder="{{translations.lbl_select}} {{translations.lbl_status}}" optionLabel="descrip"
                            [showClear]="true"></p-dropdown>
                    </div>

                    <!-- Email -->
                    <div class="p-col-12">
                        <label for="emailModal">{{translations.lbl_email}}</label>
                        <input id="emailModal" type="email" pInputText formControlName="email">
                    </div>

                    <!-- Pais -->
                    <div class="p-col-12">
                        <label for="paisModal">{{translations.lbl_country}}</label>
                        <input id="paisModal" type="text" pInputText formControlName="country">
                    </div>


                </div>
            </div>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <button pButton pRipple label="{{translations.lbl_back}}" icon="pi pi-chevron-left"
            class="p-button-warning p-mr-2" (click)="closeModal()"></button>
        <button pButton pRipple type="button" icon="pi pi-check" label="{{translations.lbl_save}}"
            (click)="updateStatus()" class="p-button-raised p-button-success"></button>
    </ng-template>
</p-dialog>

<!-- DIALOG NOT FOUND -->
<p-dialog header="Not Founded" [(visible)]="responsiveModal" [breakpoint]="{'960px': '75vw'}" [style]="{width: '50vw'}"
    [baseZIndex]="10000" [draggable]="false" [resizable]="false">
    <h6>Los siguientes emails no fueron encontrados</h6>
    <p>{{notFoundedEmails}}</p>
    <ng-template pTemplate="footer">
        <p-button (click)="responsiveModal=false" label="OK" styleClass="p-button-text"></p-button>
    </ng-template>
</p-dialog>